/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { OrdenFilters } from "../components/Orden.Filter";
import { useFormik } from "formik";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useOrdenEmpaque } from "../hooks/useOrdenEmpaque";
import { useEffect, useState } from "react";
import { OrdenTable } from "../components/Orden.Table";
import { OrdenModalDownload } from "../components/Orden.Modal.Download";
import { CampoSelectModal } from "../components/Campos.Select.Modal";
import { useSearchParams } from "react-router-dom";
import { SkeletonEmpaqueTable } from "../../../components/skeleton.empaque.table";

export const OrdenEmpaque = () => {
  const [searchParams] = useSearchParams();
  const paramsFecha = searchParams.get("fecha");
  const { getOrdenEmpaque } = useOrdenEmpaque();
  const [data, setData] = useState([]);
  const [camposSelectIsVisible, setCampoSelectIsVisible] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = () => {};

  const onCloseModal = () => {
    setCampoSelectIsVisible(false);
    setDownloadModal(false);
  };

  const { values, handleChange, setFieldValue } = useFormik({
    initialValues: {
      fecha: paramsFecha
        ? moment(paramsFecha).format("YYYY-MM-DD")
        : moment().add(1, "day").format("YYYY-MM-DD"),
      campo: 0,
      campo_name: "",
      variedad: 0,
    },
    onSubmit,
  });

  useEffect(() => {
    const getEmpaqueOrden = async () => {
      setIsLoading(true);
      try {
        const response = await getOrdenEmpaque(
          values.fecha,
          values.campo,
          values.variedad
        );
        setData(response);
      } catch (error) {
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (values.fecha !== "") {
      getEmpaqueOrden();
    }
  }, [values]);

  return (
    <Card className="my-2">
      <CardHeader style={{ textAlign: "center", fontWeight: "bold" }}>
        Orden de empaque
      </CardHeader>
      <CardBody>
        <OrdenFilters
          values={values}
          handleChange={handleChange}
          setFieldValues={setFieldValue}
          onDownloadClick={() => setDownloadModal(true)}
        />
        <br />
        {isLoading ? (
          <SkeletonEmpaqueTable />
        ) : (
          <OrdenTable ordenEmpaque={data} setData={setData} />
        )}
        <OrdenModalDownload
          values={values}
          isVisible={downloadModal}
          onClose={onCloseModal}
          onDiarioClick={() => setCampoSelectIsVisible(true)}
          disabled={data.length === 0}
        />
        <CampoSelectModal
          isVisible={camposSelectIsVisible}
          onClose={onCloseModal}
          camposOptions={data?.map((item) => ({
            id_campo: item.id_campo,
            campo: item.campo,
          }))}
          values={values}
        />
      </CardBody>
    </Card>
  );
};
